import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
/* import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf"; */

import {
  Box,
  Backdrop,
  Divider,
  Paper,
  Alert,
  Select,
  MenuItem,
  /*   Input, */
  InputLabel,
  FormControl,
  Grid,
  CircularProgress,
  /*   Table,
  TableBody, */
  /*   TableCell, */
  /*   TableHead,
  TableRow, */
  DialogTitle,
  DialogContent,
  Typography,
  Autocomplete,
  TextField,
  FormControlLabel,
  Checkbox,
  DialogActions,
  FormHelperText,
  DialogContentText,
} from "@mui/material";

import ApiService from "../../ApiService";
/* import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear"; */
import MaterialTable from "../../components/MaterialTable";
import DateFnsUtils from "@date-io/date-fns";
import { /* subMonths, */ subDays, format } from "date-fns";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Button from "../../components/Custom/Button/Button";
import { Button as MTButton } from "@mui/material";
import Dialog from "@material-ui/core/Dialog";
import ChargeForm from "../../EntityChargeConfigForm";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import TaskIcon from "@mui/icons-material/Task";
import dayjs from "dayjs";

import {
  MuiPickersUtilsProvider,
  DatePicker,
  /*   DateTimePicker, */
  TimePicker,
} from "@material-ui/pickers";
import GridContainer from "../../components/Custom/Grid/GridContainer";
import GridItem from "../../components/Custom/Grid/GridItem";
import { Delete } from "@material-ui/icons";
import { IconButton, Tooltip } from "@material-ui/core";

/* const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
  },
}))(TableCell); */

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  detailhead: {
    fontSize: 12,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  searchbar: {
    margin: theme.spacing(2),
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: "absolute",
    marginTop: 8,
    marginLeft: -65,
  },
});

class MerchantChargebackComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchantId: null,
      fromDate: null,
      toDate: null,
      declinedFrom: null,
      declinedTo: null,
      chbkFrom: null,
      chbkTo: format(new Date(), "yyyy-MM-dd"),
      refundFrom: null,
      refundTo: format(new Date(), "yyyy-MM-dd"),
      fromDateObj: null,
      toDateObj: null,
      declinedFromObj: null,
      declinedToObj: null,
      chbkFromObj: null,
      chbkToObj: new Date().setHours(0, 0, 0),
      refundFromObj: null,
      refundToObj: new Date().setHours(0, 0, 0),
      releaseFrom: null,
      releaseTo: null,
      loading: false,
      showCharges: false,
      failed: false,
      addChargePanelVisible: false,
      copyChargePanelVisible: false,
      terminalId: null,
      acquirerAccountId: null,
      acquirerAccounts: [],
      merchantTerminals: [],
      masterCharges: [],
      entityChargeConfigs: [],
      wires: [],
      responsemessage: null,
      exchangeRates: [],
      progressOpen: false,
      previousBalance: "0.00",
      copyTerminalId: null,
      success: false,
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      declinedFromTime: new Date().setHours(0, 0, 0),
      declinedToTime: new Date().setHours(23, 59, 59),
      chbkFromTime: new Date().setHours(0, 0, 0),
      chbkToTime: new Date().setHours(23, 59, 59),
      refundFromTime: new Date().setHours(0, 0, 0),
      refundToTime: new Date().setHours(23, 59, 59),
      fromTimeStr: "00:00:00",
      toTimeStr: "23:59:59",
      declinedFromTimeStr: "00:00:00",
      declinedToTimeStr: "23:59:59",
      chbkFromTimeStr: "00:00:00",
      chbkToTimeStr: "23:59:59",
      refundFromTimeStr: "00:00:00",
      refundToTimeStr: "23:59:59",
      entityType: "MERCHANT",
      open: false,
      chargeName: "",
      chargeType: "",
      newChargeType: "",
      direction: "",
      mandatory: "N",
      frequency: "",
      code: "",
      chargeTypes: null,
      chargeFrequencies: null,
      chargeDirection: null,
      newFrequency: "",
      open2: false,
      success2: false,
      failed2: false,
      responsemessage2: null,
      open3: false,

      lastUpdatedAt: null,
      showChargeDef: false,

      errors: {
        chargeName: "",
        chargeType: "",
        direction: "",
        frequency: "",
        code: "",
        newChargeType: "",
        newFrequency: "",
      },
      chargeId: null,
    };
    this.reloadData = this.reloadData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.showAddChargePanel = this.showAddChargePanel.bind(this);
    this.hideAddChargePanel = this.hideAddChargePanel.bind(this);
    this.showCopyChargePanel = this.showCopyChargePanel.bind(this);
    this.hideCopyChargePanel = this.hideCopyChargePanel.bind(this);
    this.fetchEntityMasterCharges = this.fetchEntityMasterCharges.bind(this);
    this.copyTerminalCharges = this.copyTerminalCharges.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.success && prevState.success !== this.state.success) {
      this.clearMessage();
    }
    if (this.state.failed && prevState.failed !== this.state.failed) {
      this.clearMessage();
    }
    if (this.state.success2 && prevState.success2 !== this.state.success2) {
      this.clearMessage();
    }
    if (this.state.failed2 && prevState.failed2 !== this.state.failed2) {
      this.clearMessage();
    }
  }
  clearMessage = () => {
    setTimeout(() => {
      this.setState({
        success: false,
        failed: false,
        responsemessage: null,
        success2: false,
        failed2: false,
        responsemessage2: null,
      });
    }, 3000);
  };

  handleChargesShow = () => {
    this.setState({
      showChargeDef: true,
      showCharges: false,
      fromDateObj: null,
      toDateObj: null,
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      terminalId: null,
    });
  };

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  fetchChargeById = (rowData) => {
    const id = rowData.id;
    this.setState({
      chargeId: id,
    });
    ApiService.fetchChargeById(id).then((res) => {
      if (res.data.status === "OK") {
        this.setState({
          chargeName: res.data.responseObject.name,
          chargeType: res.data.responseObject.type,
          direction: res.data.responseObject.direction,
          mandatory: res.data.responseObject.mandatory,
          frequency: res.data.responseObject.frequency,
          code: res.data.responseObject.code,
          lastUpdatedAt: res.data.responseObject.lastUpdated,
        });
      } else {
        this.setState({
          success: false,
          failed: true,
          responsemessage: res.data.responseMessage,
        });
      }
    });
  };
  handleTerminalChange = (event, newValue) => {
    this.setState({
      terminalId: newValue ? newValue.terminalId : null,
    });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
    this.fetchChargeTypes();
    this.fetchChargeFrequencies();
    this.fetchChargeDirection();
  };

  handleDeleteOpen = (rowData) => {
    this.setState({ open2: true, chargeId: rowData.id });
  };

  deleteChargeMaster = () => {
    ApiService.deleteCharge(this.state.chargeId)
      .then((res) => {
        if (res.data.status === "OK") {
          this.setState({
            success2: true,
            failed2: false,
            responsemessage2: res.data.responseMessage,
          });

          setTimeout(() => {
            this.handleDeleteClose();
          }, 3000);
          this.fetchMasterCharges();
        } else {
          this.setState({
            success2: false,
            failed2: true,
            responsemessage2: res.data.responseMessage,
          });
          setTimeout(() => {
            this.handleDeleteClose();
          }, 3000);
        }
      })
      .catch((e) => {
        this.setState({
          responsemessage2: e,
          success2: false,
          failed2: true,
        });
        setTimeout(() => {
          this.handleDeleteClose();
        }, 3000);
      });
  };
  handleDeleteClose = () => {
    this.setState({ open2: false });
  };

  handleEditOpen = (rowData) => {
    this.setState({ open3: true });
    this.fetchChargeById(rowData);
    this.fetchChargeTypes();
    this.fetchChargeFrequencies();
    this.fetchChargeDirection();
  };
  handleEditClose = () => {
    this.setState({
      open3: false,
      chargeName: "",
      chargeType: "",
      direction: "",
      mandatory: "N",
      frequency: "",
      code: "",
      errors: {},
      newChargeType: "",
      newFrequency: "",
    });
  };

  handleEditCharge = () => {
    // const nowTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

    if (this.validateFields()) {
      const {
        chargeName,
        chargeType,
        direction,
        mandatory,
        frequency,
        code,
        newChargeType,
        newFrequency,
        lastUpdatedAt,
      } = this.state;

      ApiService.updateCharge(
        chargeName,
        chargeType === "ADD NEW" ? newChargeType : chargeType,
        direction,
        mandatory,
        frequency === "ADD NEW" ? newFrequency : frequency,
        code,
        this.state.chargeId,
        lastUpdatedAt
      )
        .then((res) => {
          if (res.data.status === "OK") {
            this.setState({
              responsemessage2: res.data.responseMessage,
              success2: true,
              failed2: false,
            });
            setTimeout(() => {
              this.handleEditClose();
            }, 3000);
            this.fetchMasterCharges();
          } else {
            this.setState({
              responsemessage2: res.data.responseMessage,
              success2: false,
              failed2: true,
            });
          }
          setTimeout(() => {
            this.handleEditClose();
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            responsemessage2: err,
            success2: false,
            failed2: true,
          });
          setTimeout(() => {
            this.handleEditClose();
          }, 3000);
        });
    }
  };

  handleClose = () => {
    this.setState({
      open: false,
      chargeName: "",
      chargeType: "",
      direction: "",
      mandatory: "N",
      frequency: "",
      code: "",
      errors: {},
      newChargeType: "",
      newFrequency: "",
    });
  };

  validateFields = () => {
    const {
      chargeName,
      chargeType,
      direction,
      frequency,
      code,
      newChargeType,
      newFrequency,
    } = this.state;
    const errors = {};

    if (!chargeName) errors.chargeName = "*Charge Name is required";

    if (chargeType === "ADD NEW" && !newChargeType) {
      errors.newChargeType = "New Charge Type is required";
    } else if (!chargeType && chargeType !== "ADD NEW") {
      errors.chargeType = "Charge Type is required";
    }

    if (!direction) {
      errors.direction = "Direction is required";
    }

    if (frequency === "ADD NEW" && !newFrequency) {
      errors.newFrequency = "New Frequency is required";
    } else if (!frequency && frequency !== "ADD NEW") {
      errors.frequency = "Frequency is required";
    }
    if (!code) errors.code = "*Code is required";

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleCreateNewCharge = () => {
    if (this.validateFields()) {
      const {
        chargeName,
        chargeType,
        direction,
        mandatory,
        frequency,
        code,
        newChargeType,
        newFrequency,
      } = this.state;

      ApiService.createNewCharge(
        chargeName,
        chargeType === "ADD NEW" ? newChargeType : chargeType,
        direction,
        mandatory,
        frequency === "ADD NEW" ? newFrequency : frequency,
        code
      )
        .then((res) => {
          if (res.data.status === "OK") {
            this.setState({
              responsemessage: res.data.responseMessage,
              success: true,
              failed: false,
            });
            this.handleClose();
            this.fetchMasterCharges();
          } else {
            this.setState({
              responsemessage: res.data.responseMessage,
              success: false,
              failed: true,
            });
          }
          this.handleClose();
        })
        .catch((err) => {
          this.setState({
            responsemessage: err,
            success: false,
            failed: true,
          });
        });
    }
  };

  handleDialogCompChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === "mandatory") {
      this.setState({ mandatory: checked ? "Y" : "N" });
    } else {
      this.setState({
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };
  reloadData() {
    if (
      (this.state.terminalId === null &&
        this.state.acquirerAccountId === null) ||
      this.state.fromDateObj === null ||
      this.state.toDateObj === null
    ) {
      this.setState({
        responsemessage:
          "Please select either of Merchant Terminal and Acquirer account.Please select From Date and To Date too.",
        failed: true,
      });
      return;
    }
    this.setState({ failed: false, showCharges: true, showChargeDef: false });
    //call api functions to show chareges and wires
    this.fetchEntityMasterCharges();
    this.fetchWires();
  }

  fetchMerchantTerminals() {
    ApiService.fetchMerchantTerminals()
      .then((res) => {
        this.setState({ merchantTerminals: res.data });
      })
      .catch((e) => {});
  }

  fetchChargeTypes = () => {
    ApiService.fetchChargeTypes()
      .then((res) => {
        this.setState({
          chargeTypes: res.data,
        });
      })
      .catch((e) => {});
  };

  fetchChargeFrequencies = () => {
    ApiService.fetchChargeFrequencies()
      .then((res) => {
        this.setState({
          chargeFrequencies: res.data,
        });
      })
      .catch((e) => {});
  };

  fetchChargeDirection = () => {
    ApiService.fetchChargeDirection()
      .then((res) => {
        this.setState({
          chargeDirection: res.data,
        });
      })
      .catch((e) => {});
  };

  fetchAcquirerAccounts() {
    ApiService.fetchAcquirerAccounts()
      .then((res) => {
        this.setState({ acquirerAccounts: res.data });
      })
      .catch((e) => {});
  }

  fetchMasterCharges() {
    ApiService.fetchMasterCharges().then((res) => {
      this.setState({ masterCharges: res.data });
    });
  }

  fetchEntityMasterCharges() {
    this.setState({ enitityId: this.state.terminalId });
    this.state.enitityId = this.state.terminalId;
    var request = Object.assign({}, this.state);
    ApiService.fetchEntityChargeDetails(request).then((res) => {
      this.setState({ entityChargeConfigs: res.data });
    });
  }

  fetchWires() {
    this.setState({ enitityId: this.state.terminalId });
    this.state.enitityId = this.state.terminalId;
    var request = Object.assign({}, this.state);
    ApiService.fetchWires(request).then((res) => {
      this.setState({ wires: res.data });
    });
  }
  showAddChargePanel() {
    this.setState({ addChargePanelVisible: true });
  }
  hideAddChargePanel() {
    this.setState({ addChargePanelVisible: false });
  }
  showCopyChargePanel() {
    this.setState({ copyChargePanelVisible: true });
  }
  hideCopyChargePanel() {
    this.setState({ copyChargePanelVisible: false });
  }

  copyTerminalCharges() {
    ApiService.copyTerminalCharges(
      this.state.copyTerminalId,
      this.state.terminalId,
      this.state.fromDateObj
    ).then((res) => {
      if (res.data.status === "OK") {
        this.setState({
          responsemessage: res.data.responseMessage,
          success: true,
          failed: false,
          progressOpen: false,
        });
        this.fetchEntityMasterCharges();
      } else {
        this.setState({
          responsemessage: res.data.responseMessage,
          success: false,
          failed: true,
          progressOpen: false,
        });
      }
    });
  }

  generateWire() {
    this.setState({ enitityId: this.state.terminalId, openProgress: true });
    this.state.enitityId = this.state.terminalId;
    var request = Object.assign({}, this.state);
    ApiService.createWire(request).then((res) => {
      if (res.data.status === "OK") {
        this.setState({ failed: false, progressOpen: false });
        this.fetchWires();
      } else {
        this.setState({
          responsemessage: res.data.responseMessage,
          failed: true,
          progressOpen: false,
        });
      }
    });
  }

  deleteEntityWireChargeConfig(data) {
    data.map((d) =>
      ApiService.deleteWireCharge(d.entityWireChargeId).then((res) => {
        this.fetchEntityMasterCharges();
      })
    );
  }

  deleteWire(wireId) {
    ApiService.deleteWire(
      wireId,
      this.state.terminalId,
      this.state.acquirerAccountId
    ).then((res) => {
      this.fetchWires();
    });
  }
  approveWire(wireId) {
    this.setState({ progressOpen: true });
    ApiService.approveWire(
      wireId,
      this.state.terminalId,
      this.state.acquirerAccountId
    ).then((res) => {
      this.fetchWires();
      this.setState({ progressOpen: false });
    });
  }
  showPdf(wireId) {
    ApiService.fetchWirePdf(
      wireId,
      format(this.state.fromDateObj, "yyyyMMdd") +
        "_" +
        format(this.state.toDateObj, "yyyyMMdd")
    );
  }

  showXLS(wireId) {
    ApiService.fetchWireXls(
      wireId,
      format(this.state.fromDateObj, "yyyyMMdd") +
        "_" +
        format(this.state.toDateObj, "yyyyMMdd")
    );
  }

  componentDidMount() {
    this.fetchMerchantTerminals();
    this.fetchAcquirerAccounts();
    this.fetchMasterCharges();
  }

  headCells2 = [
    { id: "ChargevName", numeric: false, label: "ChargevName" },
    { id: "Value", numeric: true, label: "Value" },
    { id: "Total", numeric: true, label: "Total" },
    { id: "Direction", numeric: false, label: "Direction" },
  ];

  MenuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 4.5 + this.ITEM_PADDING_TOP,
        width: 380,
      },
    },
  };
  tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  render() {
    const { classes } = this.props;
    const {
      terminalId,
      merchantTerminals,
      open,
      chargeName,
      chargeType,
      direction,
      mandatory,
      frequency,
      code,
      errors,
      newChargeType,
      newFrequency,
    } = this.state;
    return (
      <React.Fragment>
        <Paper style={{ margin: "1em", padding: "1em" }}>
          <Typography component="h2" variant="h6" color="primary" gutterBottom>
            Charges Management
          </Typography>
          <Divider light className={classes.searchbar} />
          {this.state.failed && (
            <Alert severity="error" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          {this.state.success && (
            <Alert severity="success" elevation="0">
              {" "}
              {this.state.responsemessage}
            </Alert>
          )}
          &nbsp;
          <GridContainer>
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <GridContainer>
                  <GridItem xs={6} sm={6} md={3} lg={3}>
                    <DatePicker
                      autoOk
                      label="From"
                      format="dd MMM yyyy"
                      value={this.state.fromDateObj}
                      onChange={(val) =>
                        this.setState({
                          fromDateObj: val,
                          fromDate: format(val, "yyyy-MM-dd"),
                          declinedFromObj: val,
                          declinedFrom: format(val, "yyyy-MM-dd"),
                          chbkFromObj: subDays(val, 180),
                          chbkFrom: format(subDays(val, 180), "yyyy-MM-dd"),
                          refundFromObj: subDays(val, 180),
                          refundFrom: format(subDays(val, 180), "yyyy-MM-dd"),
                          releaseFrom: subDays(val, 180),
                        })
                      }
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3} lg={3}>
                    <TimePicker
                      label="From Time"
                      views={["hours", "minutes", "seconds"]}
                      value={this.state.fromTime}
                      format="HH:mm:ss"
                      onChange={(val) =>
                        this.setState({
                          fromTime: val,
                          declinedFromTime: val,
                          fromTimeStr: format(val, "HH:mm:ss"),
                          declinedFromTimeStr: format(val, "HH:mm:ss"),
                        })
                      }
                    ></TimePicker>
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3} lg={3}>
                    <DatePicker
                      autoOk
                      label="To"
                      format="dd MMM yyyy"
                      value={this.state.toDateObj}
                      onChange={(val) =>
                        this.setState({
                          toDateObj: val,
                          toDate: format(val, "yyyy-MM-dd"),
                          declinedToObj: val,
                          declinedTo: format(val, "yyyy-MM-dd"),
                          releaseTo: subDays(val, 180),
                        })
                      }
                    />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={3} lg={3}>
                    <TimePicker
                      label="To Time"
                      views={["hours", "minutes", "seconds"]}
                      value={this.state.toTime}
                      format="HH:mm:ss"
                      onChange={(val) =>
                        this.setState({
                          toTime: val,
                          declinedToTime: val,
                          toTimeStr: format(val, "HH:mm:ss"),
                          declinedToTimeStr: format(val, "HH:mm:ss"),
                        })
                      }
                    ></TimePicker>
                  </GridItem>
                </GridContainer>
              </MuiPickersUtilsProvider>
            </GridItem>
            {/* <GridItem xs={12} sm={12} md={2} lg={2}>
              <FormControl fullWidth>
                <InputLabel id="merchantTerminalSelectLabel">
                  Terminals
                </InputLabel>
                <Select
                  value={this.state.terminalId}
                  MenuProps={this.MenuProps}
                  onChange={this.handleChange}
                  name="terminalId"
                  labelId="merchantTerminalSelectLabel"
                  id="merchantTerminalSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;{" "}
                  </MenuItem>
                  {this.state.merchantTerminals &&
                    this.state.merchantTerminals.map((mt) => (
                      <MenuItem key={mt.terminalId} value={mt.terminalId} dense>
                        {mt.label + "-" + mt.terminalCardType}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </GridItem> */}
            <Grid item xs={12} sm={12} md={2} lg={2}>
              <FormControl fullWidth>
                <Autocomplete
                  value={
                    merchantTerminals.find(
                      (mt) => mt.terminalId === terminalId
                    ) || null
                  }
                  onChange={this.handleTerminalChange}
                  options={merchantTerminals}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.terminalId}>
                        {option.label + "-" + option.terminalCardType}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      labelId="merchantTerminalSelectLabel"
                      id="merchantTerminalSelect"
                      label="Terminals"
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <GridItem xs={12} sm={12} md={1} lg={1}>
              <Typography variant="h6">OR</Typography>
            </GridItem>
            <GridItem xs={12} sm={12} md={2} lg={2}>
              <FormControl fullWidth>
                <InputLabel id="acquirerAccountSelectLabel">
                  Acquirer Acc
                </InputLabel>
                <Select
                  value={this.state.acquirerAccountId}
                  MenuProps={this.MenuProps}
                  onChange={this.handleChange}
                  name="acquirerAccountId"
                  labelId="acquirerAccountSelectLabel"
                  id="acquirerAccountSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;
                  </MenuItem>
                  {/*this.state.acquirerAccounts && this.state.acquirerAccounts.map((ac) =>
							  	 <MenuItem key={ac.acquirerAccountId} value={ac.acquirerAccountId} dense>{ac.userName +"-" 
										+ ac.mid + "-" + ac.settlementCurrency + "-" + ac.paymentMode.mode + "-" + ac.ardType.type}</MenuItem>
							)*/}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem
              xs={12}
              sm={12}
              md={4}
              lg={1}
              style={{ marginLeft: "0.1em", marginTop: "1em" }}
            >
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.button}
                  onClick={this.reloadData}
                >
                  Go
                </Button>
                {this.state.loading && (
                  <CircularProgress
                    size={25}
                    className={classes.buttonProgress}
                  />
                )}
              </Grid>
            </GridItem>

            <Grid container justifyContent="flex-end">
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={this.handleChargesShow}
                  sx={{ flex: 1, minWidth: "150px" }}
                >
                  Charge Definition
                </Button>
              </Box>
            </Grid>

            <Dialog open={open} onClose={this.handleClose}>
              <DialogTitle>Add Charge</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Code"
                  fullWidth
                  variant="outlined"
                  name="code"
                  value={code}
                  onChange={this.handleDialogCompChange}
                  error={!!errors.code}
                  helperText={errors.code}
                />
                <TextField
                  margin="dense"
                  label="Charge Name"
                  fullWidth
                  variant="outlined"
                  name="chargeName"
                  value={chargeName}
                  onChange={this.handleDialogCompChange}
                  error={!!errors.chargeName}
                  helperText={errors.chargeName}
                />
                <FormControl
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  error={!!errors.chargeType}
                >
                  <InputLabel>Charge Type</InputLabel>
                  <Select
                    name="chargeType"
                    value={chargeType}
                    onChange={this.handleDialogCompChange}
                    label="Charge Type"
                  >
                    {this.state.chargeTypes &&
                      this.state.chargeTypes.map((chargeType, index) => (
                        <MenuItem key={index} value={chargeType}>
                          {chargeType}
                        </MenuItem>
                      ))}
                    <MenuItem value="ADD NEW">ADD NEW</MenuItem>
                  </Select>

                  {errors.chargeType && (
                    <FormHelperText>{errors.chargeType}</FormHelperText>
                  )}
                </FormControl>

                {this.state.chargeType === "ADD NEW" && (
                  <TextField
                    margin="dense"
                    label="Enter New Charge Type"
                    fullWidth
                    variant="outlined"
                    name="newChargeType"
                    value={newChargeType}
                    onChange={this.handleDialogCompChange}
                    error={!!errors.newChargeType}
                    helperText={errors.newChargeType}
                    inputProps={{ maxLength: 10 }}
                  />
                )}
                <FormControl
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  error={!!errors.direction}
                >
                  <InputLabel>Direction</InputLabel>
                  <Select
                    name="direction"
                    value={direction}
                    onChange={this.handleDialogCompChange}
                    label="Direction"
                  >
                    <MenuItem value="DEBIT">DEBIT</MenuItem>
                    <MenuItem value="CREDIT">CREDIT</MenuItem>
                  </Select>
                  {errors.direction && (
                    <FormHelperText>{errors.direction}</FormHelperText>
                  )}
                </FormControl>

                <FormControl
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  error={!!errors.frequency}
                >
                  <InputLabel>Frequency</InputLabel>
                  <Select
                    name="frequency"
                    value={frequency}
                    onChange={this.handleDialogCompChange}
                    label="Frequency"
                  >
                    {this.state.chargeFrequencies &&
                      this.state.chargeFrequencies.map((frequency, index) => (
                        <MenuItem key={index} value={frequency}>
                          {frequency}
                        </MenuItem>
                      ))}
                    <MenuItem value="ADD NEW">ADD NEW</MenuItem>
                  </Select>
                  {errors.frequency && (
                    <FormHelperText>{errors.frequency}</FormHelperText>
                  )}
                </FormControl>

                {this.state.frequency === "ADD NEW" && (
                  <TextField
                    margin="dense"
                    label="Enter New Frequency"
                    fullWidth
                    variant="outlined"
                    name="newFrequency"
                    value={newFrequency}
                    onChange={this.handleDialogCompChange}
                    error={!!errors.newFrequency}
                    helperText={errors.newFrequency}
                    inputProps={{ maxLength: 10 }}
                  />
                )}

                <FormControlLabel
                  control={
                    <Checkbox
                      name="mandatory"
                      checked={mandatory === "Y"}
                      onChange={this.handleDialogCompChange}
                    />
                  }
                  label="Mandatory"
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleCreateNewCharge}
                  color="primary"
                  variant="contained"
                >
                  Add
                </Button>
                <Button
                  onClick={this.handleClose}
                  color="primary"
                  variant="contained"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={this.state.open2}
              onClose={this.handleDeleteClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
            >
              <DialogTitle id="alert-dialog-title">Delete Charge</DialogTitle>
              {this.state.failed2 && (
                <Alert severity="error" elevation="0">
                  {" "}
                  {this.state.responsemessage2}
                </Alert>
              )}
              {this.state.success2 && (
                <Alert severity="success" elevation="0">
                  {" "}
                  {this.state.responsemessage2}
                </Alert>
              )}

              <DialogContent>
                <DialogContentText id="delete-charge-dialog-description">
                  Are you sure you want to delete this charge? This action
                  cannot be undone.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.deleteChargeMaster}
                  color="primary"
                  variant="contained"
                >
                  Delete
                </Button>
                <Button
                  onClick={this.handleDeleteClose}
                  color="primary"
                  variant="contained"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={this.state.open3}
              onClose={this.handleEditClose}
              fullWidth
            >
              <DialogTitle>Edit Charge</DialogTitle>
              {this.state.failed2 && (
                <Alert severity="error" elevation="0">
                  {" "}
                  {this.state.responsemessage2}
                </Alert>
              )}
              {this.state.success2 && (
                <Alert severity="success" elevation="0">
                  {" "}
                  {this.state.responsemessage2}
                </Alert>
              )}
              <DialogContent>
                <>
                  <TextField
                    margin="dense"
                    label="Code"
                    fullWidth
                    variant="outlined"
                    name="code"
                    value={code}
                    onChange={this.handleDialogCompChange}
                    error={!!errors.code}
                    helperText={errors.code}
                  />
                  <TextField
                    margin="dense"
                    label="Charge Name"
                    fullWidth
                    variant="outlined"
                    name="chargeName"
                    value={chargeName}
                    onChange={this.handleDialogCompChange}
                    error={!!errors.chargeName}
                    helperText={errors.chargeName}
                  />
                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    error={!!errors.chargeType}
                  >
                    <InputLabel>Charge Type</InputLabel>
                    <Select
                      name="chargeType"
                      value={chargeType}
                      onChange={this.handleDialogCompChange}
                      label="Charge Type"
                    >
                      {this.state.chargeTypes &&
                        this.state.chargeTypes.map((chargeType, index) => (
                          <MenuItem key={index} value={chargeType}>
                            {chargeType}
                          </MenuItem>
                        ))}
                      <MenuItem value="ADD NEW">ADD NEW</MenuItem>
                    </Select>

                    {errors.chargeType && (
                      <FormHelperText>{errors.chargeType}</FormHelperText>
                    )}
                  </FormControl>

                  {this.state.chargeType === "ADD NEW" && (
                    <TextField
                      margin="dense"
                      label="Enter New Charge Type"
                      fullWidth
                      variant="outlined"
                      name="newChargeType"
                      value={newChargeType}
                      onChange={this.handleDialogCompChange}
                      error={!!errors.newChargeType}
                      helperText={errors.newChargeType}
                      inputProps={{ maxLength: 10 }}
                    />
                  )}
                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    error={!!errors.direction}
                  >
                    <InputLabel>Direction</InputLabel>
                    <Select
                      name="direction"
                      value={direction}
                      onChange={this.handleDialogCompChange}
                      label="Direction"
                    >
                      <MenuItem value="DEBIT">DEBIT</MenuItem>
                      <MenuItem value="CREDIT">CREDIT</MenuItem>
                    </Select>
                    {errors.direction && (
                      <FormHelperText>{errors.direction}</FormHelperText>
                    )}
                  </FormControl>

                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    error={!!errors.frequency}
                  >
                    <InputLabel>Frequency</InputLabel>
                    <Select
                      name="frequency"
                      value={frequency}
                      onChange={this.handleDialogCompChange}
                      label="Frequency"
                    >
                      {this.state.chargeFrequencies &&
                        this.state.chargeFrequencies.map((frequency, index) => (
                          <MenuItem key={index} value={frequency}>
                            {frequency}
                          </MenuItem>
                        ))}
                      <MenuItem value="ADD NEW">ADD NEW</MenuItem>
                    </Select>
                    {errors.frequency && (
                      <FormHelperText>{errors.frequency}</FormHelperText>
                    )}
                  </FormControl>

                  {this.state.frequency === "ADD NEW" && (
                    <TextField
                      margin="dense"
                      label="Enter New Frequency"
                      fullWidth
                      variant="outlined"
                      name="newFrequency"
                      value={newFrequency}
                      onChange={this.handleDialogCompChange}
                      error={!!errors.newFrequency}
                      helperText={errors.newFrequency}
                      inputProps={{ maxLength: 10 }}
                    />
                  )}

                  <FormControlLabel
                    control={
                      <Checkbox
                        name="mandatory"
                        checked={mandatory === "Y"}
                        onChange={this.handleDialogCompChange}
                      />
                    }
                    label="Mandatory"
                  />
                </>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={this.handleEditCharge}
                  color="primary"
                  variant="contained"
                >
                  Save
                </Button>
                <Button
                  onClick={this.handleEditClose}
                  color="primary"
                  variant="contained"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {this.state.showChargeDef && (
                <MaterialTable
                  style={{ margin: "1em 0 0 0" }}
                  title="Charge Definition"
                  icons={this.tableIcons}
                  columns={[
                    { title: "Name", field: "name" },
                    {
                      title: "Code",
                      field: "code",
                      cellStyle: {
                        minWidth: 200,
                        maxWidth: 200,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      },
                      headerStyle: {
                        minWidth: 200,
                        maxWidth: 200,
                      },
                    },
                    { title: "Type", field: "type" },
                    { title: "Direction", field: "direction" },
                    { title: "Mandatory", field: "mandatory" },
                    { title: "Frequency", field: "frequency" },
                    {
                      title: "Actions",
                      render: (rowData) => (
                        <div>
                          <Tooltip title="Edit Charge">
                            <IconButton
                              color="primary"
                              onClick={() => this.handleEditOpen(rowData)}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Charge">
                            <IconButton
                              color="primary"
                              onClick={() => this.handleDeleteOpen(rowData)}
                            >
                              <Delete />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    },
                  ]}
                  data={this.state.masterCharges}
                  actions={[
                    {
                      icon: (props) => (
                        <MTButton
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.button}
                          startIcon={<AddBox />}
                        >
                          Add New Charge
                        </MTButton>
                      ),
                      tooltip: "Add charge",
                      isFreeAction: true,
                      onClick: (event) => this.handleClickOpen(),
                    },
                  ]}
                  options={{
                    search: false,
                    exportButton: false,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 30],
                    padding: "dense",
                    showEmptyDataSourceMessage: true,
                    paginationType: "stepped",
                    selection: false,
                    emptyRowsWhenPaging: false,
                    tableLayout: "fixed",
                  }}
                />
              )}
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {this.state.showCharges && (
                <MaterialTable
                  style={{ margin: "1em 0 0 0" }}
                  title="Configured charges"
                  icons={this.tableIcons}
                  columns={[
                    { field: "chargeDescription", title: "Name" },
                    { field: "chargeValue", type: "datetime", title: "value" },
                    { field: "charge.type", title: "Type" },
                    { field: "charge.direction", title: "Direction" },
                    { field: "charge.frequency", title: "Frequency" },
                    {
                      field: "validFrom",
                      title: "From",
                      render: (rowData) => (
                        <Typography noWrap="true" variant="caption">
                          {format(new Date(rowData.validFrom), "dd MMM yyyy")}
                        </Typography>
                      ),
                    },
                    {
                      field: "validTo",
                      title: "To",
                      render: (rowData) => (
                        <Typography noWrap="true" variant="caption">
                          {format(new Date(rowData.validTo), "dd MMM yyyy")}
                        </Typography>
                      ),
                    },
                    { field: "chargeCurrency", title: "Currency" },
                  ]}
                  data={this.state.entityChargeConfigs}
                  actions={[
                    {
                      icon: (props) => (
                        <MTButton
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.button}
                          startIcon={<FileCopyIcon />}
                        >
                          Copy Charge
                        </MTButton>
                      ),
                      tooltip: "Copy charge",
                      isFreeAction: true,
                      onClick: (event) => this.showCopyChargePanel(),
                    },
                    {
                      icon: (props) => (
                        <MTButton
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.button}
                          startIcon={<TaskIcon />}
                        >
                          Apply Charge
                        </MTButton>
                      ),
                      tooltip: "Apply Charge",
                      isFreeAction: true,
                      onClick: (event) => this.showAddChargePanel(),
                    },
                    {
                      tooltip: "Delete selected charge",
                      icon: (props) => <DeleteOutline {...props} />,
                      onClick: (evt, data) =>
                        this.deleteEntityWireChargeConfig(data),
                    },
                  ]}
                  options={{
                    search: false,
                    exportButton: false,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 30],
                    padding: "dense",
                    showEmptyDataSourceMessage: true,
                    paginationType: "stepped",
                    selection: true,
                    emptyRowsWhenPaging: false,
                    tableLayout: "fixed",
                  }}
                />
              )}
            </GridItem>
          </GridContainer>
          <Dialog
            open={this.state.addChargePanelVisible}
            onClose={this.hideAddChargePanel}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.hideAddChargePanel}
            >
              Apply Charge
            </DialogTitle>
            <DialogContent>
              <ChargeForm
                masterCharges={this.state.masterCharges}
                fromDate={this.state.fromDate}
                toDate={this.state.toDate}
                terminalId={this.state.terminalId}
                accountId={this.state.acquirerAccountId}
                reloadData={this.reloadData}
              />
            </DialogContent>
          </Dialog>
          <Dialog
            open={this.state.copyChargePanelVisible}
            onClose={this.hideCopyChargePanel}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.hideCopyChargePanel}
            >
              Copy Charges
            </DialogTitle>
            <DialogContent>
              <FormControl
                sx={{ minWidth: "250px", marginBottom: "5px" }}
                fullWidth
              >
                <InputLabel id="copyTerminalSelectLable">
                  Copy from Terminal:
                </InputLabel>
                <Select
                  value={this.state.copyTerminalId}
                  MenuProps={this.MenuProps}
                  onChange={this.handleChange}
                  name="copyTerminalId"
                  labelId="copyTerminalSelectLable"
                  id="copyTerminalIdSelect"
                >
                  <MenuItem key="" value="">
                    &nbsp;{" "}
                  </MenuItem>
                  {this.state.merchantTerminals &&
                    this.state.merchantTerminals.map((mt) => (
                      <MenuItem key={mt.terminalId} value={mt.terminalId} dense>
                        {mt.label + "-" + mt.terminalCardType}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <Box align="center">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.button}
                  onClick={this.copyTerminalCharges}
                >
                  Copy
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        </Paper>
        <Backdrop open={this.state.progressOpen} className={classes.backdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </React.Fragment>
    );
  }
}
export default withStyles(useStyles)(MerchantChargebackComponent);
